import React from 'react';
import './contact.scss';

const MAP_LISTING_URL = 'https://www.google.com/maps?cid=7890819195943865663';
const MAP_DIRECTIONS_URL = 'https://www.google.com/maps/dir/?api=1&destination=57+Purple+Sage+Dr,+Brampton,+ON+L6P+4P5';
const MAP_EMBED_URL = 'https://maps.google.com/maps?q=43.7704012,-79.656944&hl=en&z=16&t=h&output=embed';

export default function MapLocation() {
    return (
        <section className="deneb_map">
            <div className="container">
                <div className="section_title">
                    <h2>Our Location</h2>
                    <p>Visit Riseup Technology Inc at our Canada office in Brampton.</p>
                </div>
                <div className="map_box">
                    <iframe
                        src={MAP_EMBED_URL}
                        title="Riseup Technology Inc office location"
                        width="600"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="strict-origin-when-cross-origin"
                    ></iframe>
                    <div className="map_place_card">
                        <h4>Riseup Technology Inc</h4>
                        <p>57 Purple Sage Dr, Brampton, ON L6P 4P5</p>
                        <div className="map_place_links">
                            <a href={MAP_LISTING_URL} target="_blank" rel="noreferrer">View larger map</a>
                            <a href={MAP_DIRECTIONS_URL} target="_blank" rel="noreferrer">Directions</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
